import { useQuery } from "react-query";
import { getEmployeeBilingual } from "../../../../../actions/Utilities/EmployeeBilingual";

export default function useGetEmployeeBilingual() {
  return useQuery("GetEmployeeBilingual", getEmployeeBilingual, {
    refetchOnWindowFocus: false,
  });
}
